import { Space, Tabs } from "antd";
import Page from "../shared/Page";
import Simple from "./Simple";
import { useTranslation } from "react-i18next";
import WithFactor from "./WithFactor";

const PaymentLink = () => {
    const { t } = useTranslation();
    return <Page id="payment-link" title="paymentLink" className="page">
        <Space direction="vertical" size={"large"}>
            <Tabs
                //onChange={onChange}
                type="card"
                items={[{
                    key: "simple-link",
                    label: t("simpleLink") ?? "",
                    children: <Simple />
                },
                {
                    key: "with-factor-link",
                    label: t("linkWithFactor") ?? "",
                    children: <WithFactor />
                }]}
                tabBarStyle={{ marginBottom: 0 }}
            />
        </Space>
    </Page>;;
}
export default PaymentLink;